import { DateTime } from 'luxon';

const transformHistogram = (slices) =>
    slices.map((row) => ({
        ...row,
        left: DateTime.fromISO(row.left),
        right: DateTime.fromISO(row.right)
    }));

export const transformColumnStats = (stats) => {
    if (stats.typeFamily !== 'TIMESTAMP' && stats.typeFamily !== 'DATE') {
        return stats;
    }

    return {
        ...stats,
        min: DateTime.fromISO(stats.min),
        max: DateTime.fromISO(stats.max),
        avg: DateTime.fromISO(stats.avg),
        histogram: transformHistogram(stats.histogram)
    };
};
